<template>
  <div :id="chartId" :style="chartStyle"></div>
</template>

<script>
export default {
  props: {
    chartId: { type: String, required: true },
    chartStyle: { type: String, default: 'width: 300px; height: 500px' },
    title: { type: String, default: '' },
    tooltipData: { type: Object, default: () => { return {} } },
    xAxisData: { type: Object, default: () => { return {} } },
    yAxisData: { type: Object, default: () => { return {} } },
    hasYAxis: { type: Boolean, default: true },
    series: { type: Array, default: () => { return [] } },
    legend: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      lastSeries: null,
      myEChart: null
    }
  },
  watch: {
    'series': {
      handler: function () {
        if (JSON.stringify(this.series) !== this.lastSeries) {
          this.lastSeries = JSON.stringify(this.series)
          if (this.myEChart) this.myEChart.dispose()
          this.initECharts()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.initECharts()
  },
  methods: {
    initECharts () {
      this.myEChart = window.echarts.init(document.getElementById(this.chartId))
      this.myEChart.setOption(this.createChartOptionObject())
    },
    createChartOptionObject () {
      let chartOptionObject = {}
      chartOptionObject.tooltip = this.tooltipData

      // Add title object
      if (this.title !== '') {
        chartOptionObject.title = {
          text: this.title
        }
      }

      // Add legend Object
      if (!window._.isEmpty(this.legend)) {
        chartOptionObject.legend = this.legend
      }

      // Add X-Axis
      if (!window._.isEmpty(this.xAxisData)) {
        chartOptionObject.xAxis = this.xAxisData
      }

      // Add Y-Axis
      if (this.hasYAxis) {
        chartOptionObject.yAxis = this.yAxisData
      }

      // Add series that contain chart data
      chartOptionObject.series = this.series
      return chartOptionObject
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/abstract_components/ECharts.vue